import { render } from "./MainHeader.vue?vue&type=template&id=57f3ef28"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/lucas/projects/distrisuper/pc-21/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__